<!-- PLATFORM FEATURES SECTION -->
<section class="py-5 bg-white">
  <div class="container">

    <!-- Header -->
    <div class="text-center mb-5">
      <span class="badge rounded-pill bg-success-subtle text-success px-3 py-2 mb-3">
        Platform Features
      </span>

      <h2 class="fw-bold mt-3">
        Everything You Need for <span class="text-success">BEE Excellence</span>
      </h2>

      <p class="text-muted mt-2">
        From programme setup to SANAS verification, GovFlow provides the tools
        to achieve and maintain your target BEE level.
      </p>
    </div>

    <!-- Grid -->
    <div id="platform_features_grid" class="row g-4"></div>

    <!-- Feature Card Template -->
    <template id="platform_feature_template">
      <div class="col-md-6 col-lg-4">
        <div class="h-100 p-4 border rounded-4 shadow-sm bg-white">

          <div
            class="feature_icon_wrapper d-flex align-items-center justify-content-center mb-3 bg-success-subtle rounded-circle"
          >
            <i class="feature_icon bi text-success fs-4"></i>
          </div>

          <h5 class="feature_title fw-semibold mb-2"></h5>

          <p class="feature_description text-muted mb-0 text-sm"></p>

        </div>
      </div>
    </template>

  </div>
</section>
